<i18n>
{
  "en": {
    "monday": "M",
    "tuesday": "T",
    "wednesday": "W",
    "thursday": "R",
    "friday": "F",
    "saturday": "S",
    "sunday": "U",
    "titleField": "Select one or more days of the weeks"
  },
  "es": {
    "monday": "L",
    "tuesday": "M",
    "wednesday": "X",
    "thursday": "J",
    "friday": "V",
    "saturday": "S",
    "sunday": "D",
    "titleField": "Selecciona uno o varios de dias de la semana"
  }
}
</i18n>

<template>
  <div class="my-2">
    <p v-if="!readOnly" class="mb-0">{{ $t('titleField') + ' *'}}</p>
    <div class="d-flex justify-content-center align-content-center">
      <v-btn
        v-for="(value, day) in weekDays"
        :key="day"
        :color="value ? 'secondary' : 'primary'"
        :outlined="!value"
        :class="readOnly && 'is_read_only'"
        x-small
        class="ma-1 black--text"
        fab
        @click="onClickDay(value, day)"
        retain-focus-on-click
      >
        {{ $t(day) }}
      </v-btn>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';
import Component from 'vue-class-component';
import { Prop, Watch } from 'vue-property-decorator';

@Component
export default class DynameatSelectDaysWeek extends Vue {
  weekDays = {
    monday: false,
    tuesday: false,
    wednesday: false,
    thursday: false,
    friday: false,
    saturday: false,
    sunday: false,
  }

  @Prop({
    Object,
    validator(value) {
      const days = ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'];
      const hasDay = days.filter((day) => Object.keys(value).includes(day));
      return hasDay.length === days.length;
    }
  }) actualWeekDays;

  @Prop({ Boolean, default: false }) readOnly;

  @Watch('actualWeekDays', { immediate: true })
  onActualWeekDaysChanged(updatedWeekDays) {
    if (updatedWeekDays) {
      this.weekDays = updatedWeekDays;
    }
  }

  onClickDay(value, day) {
    if (!this.readOnly) {
      this.onChangeDayToggle(value, day);
      this.$emit('daysSelected', this.weekDays);
    }
  }

  onChangeDayToggle(value, day) {
    this.weekDays[day] = !value;
  }
}

</script>

<style scoped>
.is_read_only {
  cursor: default;
  pointer-events: none
 }
</style>
